import { render, staticRenderFns } from "./DocumentoSelect.vue?vue&type=template&id=c52ef258&"
import script from "./DocumentoSelect.vue?vue&type=script&lang=js&"
export * from "./DocumentoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports